<template>
    <div class="admin-unauth">
        <!-- the sign-in pages show the logo above their form; the other public pages
             (order confirm, label print) keep it in the bar -->
        <v-app-bar v-if="!isAuthPage" app flat>
            <v-spacer></v-spacer>
            <v-toolbar-title class="unauth-head-title">
                <ordit-logo width="80px"></ordit-logo>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <slot></slot>
    </div>
</template>

<script>
import OrditLogo from '@/components/layout/components/OrditLogo'
import routeType from '@/router/routeType'

const AUTH_PAGES = [
    routeType.LOGIN,
    routeType.LOGIN_TOKEN,
    routeType.PASSWORD_RESET_REQUEST,
    routeType.PASSWORD_RESET,
]

export default {
    components: { OrditLogo },
    computed: {
        isAuthPage() {
            return AUTH_PAGES.includes(this.$route.name)
        },
    },
}
</script>

<style lang="scss">
.admin-unauth {
    background-color: #fff;
    min-height: 100vh;
}

.unauth-head-title {
    font-size: 24px;
}
</style>
